export { default } from './Characters';



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/MultiAdventurer/Characters/index.js